<div class="nav">
    <a (click)="redirectToMain()">Podcast</a>
    <a (click)="redirectToAboutUs()">Über uns</a>
    <a (click)="redirectToContact()">Kontakt</a>
</div>
